<template>
  <div>
    <div
      v-for="(setParams, setIndex) in sets"
      :key="'set'+setIndex"
      class="align-center mb-2"
    >
      <div
        class="grey--text text--darken-1 d-inline-block"
        style="width: 50px"
        :class="{ 'caption': dense, 'text-body-1': !dense }"
      >
        {{ $t("training_builder.configure.set", {set: setIndex + 1}) }}:
      </div>

      <exercise-param-label-helper
        :label="$t('reps.label')"
        :dense="dense"
        :param="setParams.NMRP"
      />

      <exercise-param-label-helper
        :label="$t('rep_work.label')"
        :dense="dense"
        :param="setParams.RPWRDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('rep_rest.label')"
        :dense="dense"
        :param="setParams.RPRSDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('rest_after_set.label')"
        :dense="dense"
        :param="setParams.RSSTDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.dropdown.contraction_type.title')"
        :dense="dense"
        :param="setParams.CNTDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('relaxation.label')"
        :dense="dense"
        :param="setParams.RLDR"
        suffix="s"
      />
    </div>
  </div>
</template>
<script>

import ExerciseParamLabelHelper from '@/components/training-builder/ExerciseParamLabelHelper.vue'

export default {
  name: 'MobilityParamsView',
  components: { ExerciseParamLabelHelper },
  props: {
    sets: {
      type: Array,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    hasRealizations: {
      type: Boolean,
      default: false
    }
  }
}
</script>
